<template>
  <div class="orders-scheduler">
    <div class="orders-scheduler-box box is-shadowless is-radiusless">
      <h1 class="title is-3">Scheduler</h1>

      <b-field grouped group-multiline style="margin-bottom: 20px">
        <base-select
          v-model="contractId"
          :service="$options.contractService"
          fetch-func="all"
          :fetch-params="{
            includes: 'contractor',
          }"
          :fetch-on-init="false"
          label="Contract"
          preselect-on-one
          hidden-on-one
          @change="(option) => (contract = option)"
          ref="selectContract"
        >
          <template #customLabel="{ option }">
            {{ `${option.contractor.name} - ${option.name}` }}
          </template>
        </base-select>
      </b-field>

      <b-tabs v-model="activeTab">
        <b-tab-item label="Tasks">
          <tasks
            :contract="contract || undefined"
            @generate="onTasksGenerate"
            ref="tasks"
          />
        </b-tab-item>
        <b-tab-item label="Import Values">
          <import-values :contract="contract || undefined" ref="importValues" />
        </b-tab-item>
        <b-tab-item label="Calendar">
          <calendar :operations="operations" />
        </b-tab-item>
        <b-tab-item label="Activities">
          <activities
            :contract="contract ? contract.id : ''"
            @fetch="onActivitiesFetch"
            ref="activities"
          />
        </b-tab-item>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import BaseSelect from "@/components/partials/BaseSelect";
import Activities from "./activities";
import Calendar from "./calendar";
import ImportValues from "./import-values";
import Tasks from "./tasks";
import { ContractService } from "@/services/contract.service";
import { getFilter, setFilter } from "@/helpers/globalFilters";

export default {
  contractService: ContractService,
  components: {
    BaseSelect,
    Activities,
    Calendar,
    ImportValues,
    Tasks,
  },
  data: () => ({
    contractId: "",
    contract: "",
    operations: [],
    activeTab: 0,
  }),
  async mounted() {
    await this.$refs.selectContract.fetchOptions();
    const contractId = getFilter("contract_id");
    if (contractId) this.contractId = contractId;
  },
  watch: {
    contractId(contractId) {
      setFilter("contract_id", contractId);
    },
  },
  methods: {
    onTasksGenerate() {
      this.$refs.tasks.fetchTasks();
      this.$refs.activities.fetchOrders();
    },
    onActivitiesFetch(orders) {
      this.operations = orders.reduce((acc, v) => {
        if (v.operations) {
          acc.push(
            ...v.operations.map((op) => {
              op.order = {
                id: v.id,
                orderId: v.orderId,
                scheduledLog: v.scheduledLog,
              };
              return op;
            })
          );
        }
        return acc;
      }, []);
    },
  },
};
</script>

<style lang="scss">
.orders-scheduler-box {
  min-height: calc(100vh - 3.3rem);
}
</style>


// WEBPACK FOOTER //
// src/components/pages/OrdersScheduler/index.vue